import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import Utility from "../business/Utility";
import CollectionPromoApi from "mbpromo/src/collection-api/CollectionPromoApi";
import Constants from "../business/Constants";
import Pristine from "pristinejs";
import GigyaManager from "../business/GigyaManager";

class ModificaDatiCtrl extends SmartComponent {
	constructor(element, parentComponent, params) {
		super(element, parentComponent, params);
		this.chat = new Promise((resolve) => {
			// eslint-disable-next-line no-undef
			if (typeof window.$ec === undefined) {
				if (!window.checkIntervalChat) {
					window.checkIntervalChat = setInterval(function () {
						// eslint-disable-next-line no-undef
						if (window.$ec) {
							clearInterval(window.checkIntervalChat);
							resolve();
						}
					}, 500);
				}
			} else {
				return resolve();
			}
		});
		this.$pageContainer = $('.visual-background');
		this.emailLoggedUser = "";
		this.submitAnagraficaInProgress = false;
		this.collectionPromoApi = new CollectionPromoApi({promoCode: Constants.API_PROMOCODE});
		this.addressValidationRegexp = /^[a-zA-Z0-9àáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð ,.'-/°]{2,120}$/;
		this.init();
	}

	init() {
		Utility.startLoader();
		Utility.enableHolidaysMessage();
		this.getAreaPersonale();
	}

	isChatReady() {
		return this.chat;
	}

	getAreaPersonale() {
		GigyaManager.getLoggedUserCached().then(() => {
			this.collectionPromoApi.areaPersonale().then((resp)=>{
				let body = resp.body;
				this.userID = resp.body.gigya_uid;
				this.emailLoggedUser = resp.body.email;
				this.buildEditDataForm(resp);
				Utility.removeLoader();

				this.isChatReady().then(() => {
					if (!body.registrato) {
						// eslint-disable-next-line no-constant-condition,no-undef
						window.$ec.addUserInfo({promozione: Constants.TRACKING_PROMOCODE, pagecode: document.location.href, browserName: Utility.getDeviceInfo().browserName, browserVersione: Utility.getDeviceInfo().browserVersion, osName: Utility.getDeviceInfo().osName, osVersione: Utility.getDeviceInfo().osVersion, device: Utility.getDeviceInfo().device});
					} else {
						// eslint-disable-next-line no-constant-condition,no-undef
						window.$ec.addUserInfo({idGigya: resp.body.gigya_uid, promozione: Constants.TRACKING_PROMOCODE, pagecode: document.location.href, browserName: Utility.getDeviceInfo().browserName, browserVersione: Utility.getDeviceInfo().browserVersion, osName: Utility.getDeviceInfo().osName, osVersione: Utility.getDeviceInfo().osVersion, device: Utility.getDeviceInfo().device, email: resp.body.email, telefono: resp.body.telefono, nome: resp.body.nome, cognome: resp.body.cognome});
					}
				});

				Utility.removeLoader();
			})
		}, () => {
			window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
		})
	}

	anagraficaData() {
		let data = {
			"nome": $("[name='firstName']").val(),
			"cognome": $("[name='lastName']").val(),
			"email": this.emailLoggedUser,
			"ind_denurb": $("[name='addressType']").val(),
			"ind_toponimo": $("[name='address']").val(),
			"ind_civico": $("[name='addressNum']").val(),
			"citofono": $("[name='notes']").val(),
			"cap": $("[name='cap']").val(),
			"citta": $("[name='city']").val(),
			"provincia": $("[name='prov']").val(),
			"telefono": $("[name='tel']").val()
		}

		return data;
	}

	sendEdiToForm() {
		$('.cta-cnt .proceed').on('click', ()=> {
			let pristine = new Pristine(document.getElementById("registered-user-form"),{

			});
			pristine.addValidator($('[name="address"]')[0], (value) => {
				// here `this` refers to the respective input element
				if (!this.addressValidationRegexp.test(value)){
					return false;
				}
				return true;
			}, "Il campo contiene caratteri non consentiti", 2, false);

			pristine.addValidator($('[name="notes"]')[0], (value) => {
				// here `this` refers to the respective input element
				if (!this.addressValidationRegexp.test(value)){
					return false;
				}
				return true;
			}, "Il campo contiene caratteri non consentiti", 2, false);

			let valid = pristine.validate(); // returns true or false

			if (valid) {
				if (!this.submitAnagraficaInProgress) {
					this.submitAnagraficaInProgress = true;
					$('.error-anagrafica').remove();
					this.collectionPromoApi.modificaDati(this.anagraficaData()).then(()=>{
						Utility.removeLoader();
						this.submitAnagraficaInProgress = false;
						this.editDataModal();
						Utility.trackEvent(this.userID,"MODIFICA_DATI");
					}, (resp)=>{
						$('.registered-user').append(`<div class="error-anagrafica">${resp}</div>`);
						this.submitAnagraficaInProgress = false;
						Utility.removeLoader();
					});
				}
			}
		});
	}

	buildEditDataForm(resp) {
		let registeredUserFormHtml = Utility.buildForm(true, this.emailLoggedUser);

		this.$pageContainer.after(registeredUserFormHtml);
		this.prefillForm(resp);
		this.sendEdiToForm();
	}

	prepareCap(fillOnLoad) {
		$('[name="cap"]').on('input change', function() {
			Utility.fillCapProvCityForm($('[name="cap"]').val());
		});

		if (fillOnLoad) {
			Utility.fillCapProvCityForm($('[name="cap"]').val());
		}
	}

	editDataModal() {
		let otherCpcModal = ` <div class="feedback__modal edit-data-modal" component="FeedbackModalComponent">
								<div class="feedback__modal__wrap">
										<div class="feedback__modal__content">
											<p>La modifica dei tuoi dati è avvenuta con successo!</p>
										</div>
										<div class="feedback__modal__cta-cnt cta-cpc">
											<a href="/promozioni/raccolta-punti-colazione" class="button add-cpc" >Torna alla home</a>
										</div>
								</div>
							</div>
				   			`;

		$(this.element).append(otherCpcModal);
		this.loadChildComponents(this);
	}

	prefillForm(resp) {
		let body = resp.body;

		Utility.preCompileForm(body);
		this.prepareCap(false);

		Utility.removeLoader();
	}
}

export default ModificaDatiCtrl;